import _filters from '@/mixins/filters'

export default {
  mixins: [_filters],
  data() {
    return {
      submitStatus: null,
      editMode: false
    }
  },
  computed: {
    bills() {
      return this.$_.sortBy(this.$store.state.finances.bills, "StatementNumber")
    },
    orderedBills() {
      return this.$_.sortBy(this.bills, "StatementNumber").reverse();
    },
    lastBill() {
      return this.orderedBills[0];
    },
    notCancelled() {
      return this.$_.filter(this.bills, function (bill) {
        return bill.Status != "Cancelled";
      });
    }
  },
  methods: {
    showDeleteOption(bill) {
      // Only the most recent non-committed bill can be deleted
      return (bill.Status === 'Draft' || bill.Status === 'OnHold') && bill === this.lastBill
    },
    showHoldOption(bill) {
      // Hold must happen newest-first (in terms of draft bills)
      let newestDraftBill = this.$_.findWhere(this.orderedBills, { Status: "Draft" })
      return bill === newestDraftBill;
    },
    showReleaseOption(bill) {
      // Release must happen oldest-first (in terms of held bills)
      let oldestOnHoldBill = this.$_.findWhere(this.bills, { Status: "OnHold" })
      return bill === oldestOnHoldBill;
    },
    showCommitOption(bill) {
      // Commit must happen oldest-first (in terms of draft bills)
      let oldestDraftBill = this.$_.find(this.bills, bill => {
        return bill.Status === "Draft"
      })
      return bill === oldestDraftBill;
    },
    // showCancelOption(bill) {
    //   return;
    // },
    wordSplit: function (word) {
      var foo = "";
      var splitWord = word.split(/(?=[A-Z0-9])/);
      for (let i = 0; i < splitWord.length; i++) {
        foo += splitWord[i] + " ";
      }
      return foo;
    },
    rowClicked(item) {
      this.$store.commit("updateBillDetails", item);
    },
    toggleRow(row) {
      return row.toggleDetails();
    },
    toggleEditMode(bool, row) {
      if (bool && !this.editMode) {
        this.beforeEditingNarrative = Object.assign({}, row.item);
      }
      if (!bool && this.editMode) {
        if (!this.beforeEditingNarrative.hasOwnProperty("StatusNarrative")) {
          row.item.StatusNarrative = null;
        }
        Object.assign(row.item, this.beforeEditingNarrative);
      }
      this.editMode = bool;
    },
    previousCommittedOrCancelled(statementNumber) {
      if (statementNumber == 1) return true;

      var previousStatement = this.$_.findWhere(this.bills, {
        StatementNumber: statementNumber - 1
      });

      return (
        !previousStatement ||
        previousStatement.Status == "Committed" ||
        previousStatement.Status == "Cancelled"
      );
    }
  }
}